import { Link } from 'react-router-dom';
import { t } from 'i18next';
import type { ButtonProps as TypeProps } from 'antd/lib/button';
import type { PopoverProps } from 'antd/lib/popover';
import type { TooltipProps } from 'antd/lib/tooltip';
import type { PopconfirmProps } from 'antd/lib/popconfirm';
import { StyledButton } from './Button.styles';

import { Popover } from '../Popover';
import { Tooltip } from '../Tooltip';
import { Popconfirm } from '../Popconfirm';
import type { DataTestId } from '../../../types';

type ButtonProps = {
  to?: string;
  tooltip?: TooltipProps;
  popover?: PopoverProps;
  confirm?: PopconfirmProps & { okButtonProps?: ButtonProps; cancelButtonProps?: ButtonProps };
} & TypeProps &
  DataTestId;

function UIButton({ to, tooltip, popover, confirm, disabled, ...rest }: ButtonProps) {
  let button = <StyledButton disabled={disabled} {...rest} />;

  if (tooltip) {
    button = <Tooltip {...tooltip}>{button}</Tooltip>;
  }

  if (popover) {
    button = <Popover {...popover}>{button}</Popover>;
  }

  if (confirm) {
    button = (
      <Popconfirm okText={t('Yes')} cancelText={t('No')} disabled={disabled} {...confirm}>
        {button}
      </Popconfirm>
    );
  }

  const isEnabledLink = to && !disabled;
  if (isEnabledLink) {
    button = <Link to={to}>{button}</Link>;
  }

  return button;
}

export type { ButtonProps };
export { UIButton as Button };
